import { PlayerWorkBox, PlayerWorkBoxProps } from "./PlayerWorkBox";
import { MeetingSession, MeetingSessionMedia } from "@kalyzee/kast-web-sdk/websocket";
import React from "react";
import { getNormalUser } from "../../helpers/user";
import { FluidCanvas } from "@kalyzee/kalyzee-ui";

export interface SlavePlayerWorkBoxProps {
  ownSession: MeetingSession;
  children: React.ReactNode;
  meetingOngoing?: boolean;
  session: MeetingSession;
  mediaSession: MeetingSessionMedia;
  topBarMode?: PlayerWorkBoxProps["overlayMode"];
  isSmall?: boolean;
  mediaControls?: boolean;
}

export const SlavePlayerWorkBox: React.FC<SlavePlayerWorkBoxProps> = ({
  ownSession,
  children,
  meetingOngoing,
  session,
  mediaSession,
  topBarMode = "permanent",
  isSmall,
  mediaControls,
}) => {
  const isMe = ownSession?.id === session.id;

  const getTopBarLabel = () => {
    if (isMe) return "Vous";
    const { displayName } = session.user ? getNormalUser(session.user) : { displayName: "" };
    return displayName;

  };

  const getTobBarLabelInfo = () => {
    if (isSmall) return undefined;
    let label = mediaSession.extra?.label ?? "webcam";
    return label.charAt(0).toUpperCase() + label.slice(1);
  };

  const videoEnabled = mediaSession.video?.enabled ?? false;
  const audioEnabled = mediaSession.audio?.enabled ?? false;

  return (
    <PlayerWorkBox
      label={getTopBarLabel()}
      labelInfo={getTobBarLabelInfo()}
      overlayMode={"normal"}
      video={mediaControls ? videoEnabled : undefined}
      audio={mediaControls ? audioEnabled : undefined}
      isMe={isMe}
    >
      {meetingOngoing ? children : <FluidCanvas speed={0.5} shapeSize="big" />}
    </PlayerWorkBox>
  );
};